import Client from "../client/ApiClient"

/** RBAC EES — thay legacy /groups /staffs */
const PermissionRepository = {
  getRoles: () => Client.get("roles/"),
  createRole: (data) => Client.post("roles/", data),
  deleteRole: (roleId) => Client.delete(`roles/${roleId}/`),
  updateRole: (roleId, data) => Client.patch(`roles/${roleId}/`, data),
  getAllPermissions: () => Client.get("permissions/"),
  getRole: (roleId) => Client.get(`roles/${roleId}/`),
  updateRolePermissions: (roleId, permission_codes) =>
    Client.put(`roles/${roleId}/permissions/`, { permission_codes }),

  getUsers: () => Client.get("users/"),
  createUser: (data) => Client.post("users/", data),
  updateUser: (userId, data) => Client.patch(`users/${userId}/`, data),
  getRoleAssignments: (userId) =>
    Client.get("role-assignments/", { params: userId ? { user_id: userId } : {} }),
  assignRole: (data) => Client.post("role-assignments/", data),
  removeAssignment: (id) => Client.delete(`role-assignments/${id}/`)
}

export default PermissionRepository
